import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Select } from '../../Select/Select';
var useStyles = makeStyles(function (theme) { return ({
    labelRight: {
        marginLeft: theme.spacing(1),
    },
}); });
export var PageSizeSelect = function (_a) {
    var onChange = _a.onChange, value = _a.value, _b = _a.options, options = _b === void 0 ? [10, 25, 50] : _b;
    var styles = useStyles();
    return (React.createElement("div", null,
        React.createElement(Select, { onChange: function (event) { return onChange(parseInt("" + event.target.value)); }, value: value, inputProps: { name: 'pageSize' }, "data-name": "items-per-page" }, options.map(function (option) { return (React.createElement("option", { key: option, value: option }, option)); })),
        React.createElement("label", { className: styles.labelRight, htmlFor: "pageSize" }, "Items per page")));
};
//# sourceMappingURL=PageSizeSelect.js.map